export default __webpack_public_path__ + "static/media/spotChatbotButton.93df965e.svg";